import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getOurDoctorMessage} from 'presentation/services/getOurDoctorMessage';
import {TWENTY_FOUR_HOURS} from 'infra/libs/react-query/constants';
import {UseGetOurDoctorMessageQueryProps} from './types';

export const useGetOurDoctorMessageQuery = ({enabled}: UseGetOurDoctorMessageQueryProps) =>
	useQuery({
		queryKey: [QUERY_KEYS.OUR_DOCTOR_MESSAGE],
		queryFn: ({signal}) => getOurDoctorMessage({signal}),
		enabled,
		staleTime: TWENTY_FOUR_HOURS,
		retry: 1,
	});
